import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import cn from 'classname';
import moment from 'moment';
import _get from 'lodash/get';

const Table = props => {
	const { table, query, can, intl, deleteDiscounts, toggleSort, paginate } = props;
	const lastPaginationPage = Math.ceil(parseInt(_get(table, 'rows[0].total_count', 0))/query.limit);
	const activePage = query.offset/query.limit;
	const paginatedPages = [...Array(lastPaginationPage).keys()];
	return (
		<div className="table-container">
			<table className="simple-table discounts-table">
				<thead className="simple-table__head font-roboto-medium">
					<tr>
						{ table.headers.map((header, i) => (
							<th
								key={i}
								className={cn({
									'sort-header ': Boolean(header.direction),
									'active ': !!header.isActive
								}) +  header.direction + ' '+ header.className}
								onClick={() => toggleSort(header)}
							>
								{intl(header.title)}
							</th>
						))}
					</tr>
				</thead>
				<tbody className="simple-table__body">
					{
						table.rows.map((row, index) =>
							<tr
								key={index}
								className={cn({
									'modify-background': index % 2,
									'expired': moment(row.discounts_end_at).diff(moment()) < 0
								})}
							>
								<td className="id"><span>{ row.id }</span></td>
								<td className="partner_name"><span>{ row.partner_name }</span></td>
								<td>
									<span>{ row.partner_description_ru }</span>
								</td>
								<td className="title">{ row.partner_description_en }</td>
								{	row.discounts_end_at ? (
									<td className="discont_end">
										<span className="date">{ moment(row.discounts_end_at).format('DD.MM.YYYY') }</span>
									</td>
								):(
									<td className="discont_end">
										<span> Lifetime </span>
									</td>
								)
								}

								<td className="actions">
									<Link
										to={`discounts/edit/${row.id}`}
										className="action_edit"
									/>
									{can('delete') &&
									<a
										href="#"
										onClick={e => {
											e.preventDefault();
											deleteDiscounts(row.id);
										}}
										className="action_delete"
									/>
									}
								</td>
							</tr>
						)
					}
				</tbody>
			</table>
			<div className="table-container__pagination">
				<div className="table-container__pagination-items">
					{paginatedPages.map((page, index) => (
						<a
							className={`table-container__pagination-item ${page === activePage && 'active'}`}
							onClick={() => {paginate(page);}}
							key={index}
						>
							{page + 1}
						</a>
					))}
				</div>
			</div>
		</div>
	);
};

Table.propTypes = {
	table: PropTypes.object,
	intl: PropTypes.func,
	toggleSort: PropTypes.func,
	paginate: PropTypes.func,
	deleteDiscounts: PropTypes.func,
	sortByColumn: PropTypes.func,
	toggleNewsOffers: PropTypes.func,
	pagination: PropTypes.object,
	query: PropTypes.object,
	gotoPage: PropTypes.func,
	deleteNews: PropTypes.func,
	can: PropTypes.func
};

export default Table;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/discounts/components/table/main.js